module.exports = __webpack_public_path__ + "static/img/human-4.5bbbf837.png";